var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconOutlineRocketChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0583 23.1104C45.0583 16.3167 36.7166 10.8083 26.427 10.8083C16.1374 10.8083 7.79578 16.3125 7.79786 23.1104C7.79786 26.0708 9.38119 28.7875 12.0208 30.9104C12.4749 35.3354 10.3541 38.0229 8.92078 39.6146C13.3229 40.7646 17.8541 37.2021 19.9145 34.6396C21.9416 35.1396 24.1354 35.4146 26.427 35.4146C36.7166 35.4146 45.0583 29.9042 45.0583 23.1104ZM7.92286 43.7292L1.20203 41.9708L5.93536 36.7146C7.14161 35.3771 7.79994 34.2583 7.96036 32.8625C5.26244 30.1333 3.71036 26.7667 3.71036 23.1125C3.71036 13.4667 14.1624 6.5625 26.427 6.5625C38.6916 6.5625 49.1458 13.4667 49.1458 23.1104C49.1458 32.7563 38.6937 39.6583 26.4291 39.6583C24.6999 39.6583 22.9916 39.5208 21.3354 39.25C17.6687 42.8167 12.7145 44.9813 7.92286 43.7292Z",
    fill: "#004BB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6708 25.796C28.1643 25.796 29.375 24.533 29.375 22.9751C29.375 21.4172 28.1643 20.1543 26.6708 20.1543C25.1774 20.1543 23.9667 21.4172 23.9667 22.9751C23.9667 24.533 25.1774 25.796 26.6708 25.796Z",
    fill: "#004BB9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7812 25.796C36.2747 25.796 37.4854 24.533 37.4854 22.9751C37.4854 21.4172 36.2747 20.1543 34.7812 20.1543C33.2877 20.1543 32.077 21.4172 32.077 22.9751C32.077 24.533 33.2877 25.796 34.7812 25.796Z",
    fill: "#004BB9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5604 25.796C20.0538 25.796 21.2645 24.533 21.2645 22.9751C21.2645 21.4172 20.0538 20.1543 18.5604 20.1543C17.0669 20.1543 15.8562 21.4172 15.8562 22.9751C15.8562 24.533 17.0669 25.796 18.5604 25.796Z",
    fill: "#004BB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconOutlineRocketChat);
export default __webpack_public_path__ + "static/media/atoms-icon-outline-rocket-chat.b116a70b0e7746e8e5961e185db5dfd1.svg";
export { ForwardRef as ReactComponent };